import Vue from "vue";
import VueI18n, { LocaleMessages } from "vue-i18n";
// import { Locale } from "vant";
// import enUS from "vant/lib/locale/lang/en-US";
// Locale.use("en-US", enUS);
Vue.use(VueI18n);

function loadLocaleMessages(): LocaleMessages {
  const locales = require.context(
    "@/locales",
    true,
    /[A-Za-z0-9-_,\s]+\.json$/i
  );
  const messages: LocaleMessages = {};
  locales.keys().forEach(key => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i);
    if (matched && matched.length > 1) {
      const locale = matched[1];
      messages[locale] = locales(key);
    }
  });
  // console.log(messages);

  return {
    ...messages,
    "id-ID": messages.id,
    "en-US": messages.en,
    "zh-CN": messages.cn
  };
}

const i18n = new VueI18n({
  locale: process.env.lang || process.env.VUE_APP_I18N_LOCALE || "en-US",
  fallbackLocale:
    process.env.lang || process.env.VUE_APP_I18N_FALLBACK_LOCALE || "en-US",
  messages: loadLocaleMessages()
});

window.i18n = i18n;

export default i18n;
